import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { createPortal } from "react-dom";

const Modal = forwardRef(({ children, onClose, className = "" }, ref) => {
    const dialogRef = useRef();
    const [closing, setClosing] = useState(false);


    useImperativeHandle(ref, () => ({
        open: () => {
            if (dialogRef.current) {
                setClosing(false);
                dialogRef.current.showModal();

            }
        },
        close: () => {
            if (dialogRef.current) {
                setClosing(true);
                setTimeout(() => {
                    dialogRef.current.close();


                }, 300);
            }
        },
    }));

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                ref?.current?.close();
                if (onClose) onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    const handleClickOutside = (event) => {
        if (event.target === dialogRef.current) {
            ref?.current?.close();
            if (onClose) onClose();
        }
    };

    return createPortal(
        <dialog className={`modal ${className} ${closing ? "closing" : ""}`} ref={dialogRef} onClick={handleClickOutside}>
            <div className="modal-content">
                {children}
            </div>
        </dialog>,
        document.getElementById("modal")
    );
});

export default Modal;
